// ─────────────────────────────────────────────────────────────────────
// «THIS NEEDS A MICROSOFT SIGN-IN» — the transport's side of it (#1030).
//
// Since #1002 the API honours platform authority only on a request whose
// identity Microsoft Entra proved. A customer-door session — an e-mailed code
// or a passkey — whose account holds a platform role is refused at platform
// scope with `403 {"error":"entra_required"}`. Something has to turn that code
// into a sentence, and the thing that owns the sentence (`/sa`) imports
// `apiFetch`, so a direct call from the transport would be a cycle.
//
// A LEAF, for exactly the reason `reauthenticationSignal.ts` and
// `impersonationToken.ts` are: a registered handler, a report function the
// transport calls, and no state of its own beyond the handler.
//
// ── WHAT THIS IS NOT ───────────────────────────────────────────────
//
// Not a session ending. The person is who they were a second ago and their
// session is live; what it cannot carry is PLATFORM authority. Signing them out
// would also end the club session they may be using for their own club.
//
// Not an authorization answer either. A 403 without this code is an ordinary
// refusal — a capability the account does not hold — and telling that person
// to sign in with Microsoft would be a lie about what went wrong.
// ─────────────────────────────────────────────────────────────────────

/** The API's code. Not translated, ever — see CLAUDE.md on error CODES. */
export const ENTRA_REQUIRED = 'entra_required';

let onEntraRequired: (() => void) | null = null;

/** Registered by whatever owns the sentence — `/sa`, while it is mounted. */
export function setEntraRequiredHandler(fn: (() => void) | null): void {
  onEntraRequired = fn;
}

/**
 * Called by the transport when the API says the request needed Entra.
 *
 * A no-op with no handler registered: the refusal still reaches the caller as
 * a 403, so nothing is swallowed — it simply has no sentence where nothing is
 * mounted to say one.
 */
export function reportEntraRequired(): void {
  onEntraRequired?.();
}
